import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { en_GB, NzI18nService, th_TH } from 'ng-zorro-antd/i18n';
import { forkJoin, Subject, concatMap, of, firstValueFrom } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MeAzureApiService } from './api-azure/services';
import { AuthService } from './services/auth.service';
import { AccountResp } from './api-azure/models';
import { GlobalConfigs } from './commons/global-config';
import { isNil } from 'lodash';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  private readonly _destroying$ = new Subject<void>();

  isIframe = false;
  loginDisplay = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authService: AuthService,
    private accountService: MeAzureApiService,
  ) {  }

  async setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
    this.authService.setLoginDisplay(this.loginDisplay);
  }

  async login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.msalService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.msalService.instance.setActiveAccount(response.account);
          });
      } else {
        this.msalService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.msalService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.msalService.loginRedirect();
      }
    }
  }

  async logout() {
    this.msalService.logout();
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    /**
     * You can subscribe to MSAL events as shown below. For more info,
     * visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/events.md
     */

    if (!isNil(this.authService.getCurrentAD) && !window.location.pathname.includes('/login')) {
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(async () => {
          this.setLoginDisplay();

          const accounts = this.msalService.instance.getAllAccounts();
          if (accounts && accounts.length === 1) {
            const postLoginUrl = localStorage.getItem("SCGChem.PMM.RFQ.WebCli.postLoginUrl");
            if (!isNil(postLoginUrl)) {
              localStorage.removeItem("SCGChem.PMM.RFQ.WebCli.postLoginUrl");
              window.location.href = postLoginUrl;
            }
          }
        });
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
